<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    <ng-container *ngIf="isEditMode; else addMode">
      Edit Hauler –
      <span class="hauler-name">
        {{ haulerForm.get('name')?.value || 'Unnamed' }}
      </span>
    </ng-container>

    <ng-template #addMode>
      Add Hauler
    </ng-template>
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form [formGroup]="haulerForm" class="form-grid">
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Hauler Name</mat-label>
        <input matInput formControlName="name" required data-testId="name" maxlength="50"/>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Contact Name</mat-label>
        <input matInput formControlName="contactName" required data-testId="contactName" maxlength="50"/>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Contact Number</mat-label>
        <input matInput formControlName="contactPhone" required data-testId="contactPhone"  (input)="formatPhoneNumber($event, 1)"
          placeholder="(999) 000-0000"/>
        <mat-error *ngIf="haulerForm.get('contactPhone')?.hasError('pattern')">
          Enter a valid US contact number
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Contact Email</mat-label>
        <input matInput formControlName="contactEmail" required data-testId="contactEmail" />

        <mat-error *ngIf="haulerForm.get('contactEmail')?.hasError('email')">
          Enter a valid email
        </mat-error>
      </mat-form-field>
     </div>
     <div class="form-grid-row"> 
      <mat-form-field appearance="outline">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="addressLine1" required data-testId="addressLine1" maxlength="50"/>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="addressLine2" data-testId="addressLine2" maxlength="50"/>
      </mat-form-field>
     </div>
     <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>State</mat-label>
        <mat-select formControlName="state" name="state" placeholder="Select State"
                      (selectionChange)="onStateChanged($event.value)">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #stateSearchInput matInput placeholder="Search State..." (input)="filterState($event)"
                  class="mat-select-search-input" aria-label="Search State" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option [value]="null">Select State</mat-option>
          @for (state of filteredStates; track state.id) {
          <mat-option [value]="state.id">{{ state.state }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <mat-select formControlName="city" name="city" placeholder="Select City">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #citySearchInput matInput placeholder="Search City..." (input)="filterCity($event)"
                   class="mat-select-search-input" aria-label="Search City" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option [value]="null">Select City</mat-option>
          @for (city of filteredCities; track city.id) {
          <mat-option [value]="city.city">{{ city.city }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Zip Code</mat-label>
        <input matInput formControlName="zipCode" required data-testId="zipCode" maxlength="10"/>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Market</mat-label>
        <mat-select formControlName="marketId" required data-testId="marketId">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #marketSearchInput matInput placeholder="Search Market..." (input)="filterMarket($event)"
                class="mat-select-search-input" aria-label="Search Market" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option [value]="null">-Select Market-</mat-option>
          @for (market of filteredMarkets; track market.id) {
          <mat-option [value]="market.id">
            {{
                market.regionName
            }}
          </mat-option>
          }
        </mat-select>

      </mat-form-field>
    </div>

    <!-- Price Matrix Grid -->
    <div class="addButton">
      <button mat-raised-button color="primary"
              (click)="handleAddPricingDialog(true)" data-testId="btnAddPricing">
        <mat-icon>add</mat-icon>
        <span>Add Pricing</span>
      </button>
    </div>
    <div class="table-wrapper">
      <div class="dvHscrl mat-elevation-z8 viewport">
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
          <ng-container matColumnDef="expandIcon">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" style="
              width: 32px;
              border-right: 1px solid currentColor;
              padding-right: 24px;
              text-align: center;"></td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Actions
            </th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="mat-header-row actionwidth">Actions</th>
            <td mat-cell *matCellDef="let row">
              <div>
                <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openContextmenu(row, 'EDIT')" [disabled]="row.id === 0">
                  <mat-icon matListIcon>edit</mat-icon>
                  <span matLine></span>
                </button>
                <button mat-icon-button type="button" color="warn" title="Delete" (click)="openContextmenu(row, 'DELETE')" style="color: red;">
                  <mat-icon matListIcon>delete</mat-icon>
                  <span matLine></span>
                </button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="uom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Units
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.uomName || element.uom }}
            </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Price
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.price }}
            </td>
          </ng-container>
          <ng-container matColumnDef="fuel_Surcharge">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Fuel Surcharge
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.fuel_Surcharge }}
            </td>
          </ng-container>
          <ng-container matColumnDef="demurag_Rate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Demurag Rate
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.demurag_Rate }}
            </td>
          </ng-container>
          <ng-container matColumnDef="disposalSite">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Disposal Site
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.disposalSite }}
            </td>
          </ng-container>
          <ng-container matColumnDef="streamId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-header-row">
              Stream
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.streamName || element.streamId }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="priceMatrixColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: priceMatrixColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="priceMatrixColumns.length"
                style="color: red; text-align: center; font-weight: 500">
              No data matching the filter.
            </td>
          </tr>
        </table>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-primary type="button" (click)="onCancel()">
    Cancel
  </button>
  @if(canSave){
    <button (click)="onSubmit()" mat-raised-button color="primary" mat-primary type="submit">
      Save
    </button>
  }
</mat-dialog-actions>
